// Add your custom JS here.

/**
	 * Add class to fix and shrink the header 
	 * When the user scrolls down XXpx from the top of the document, resize the header's font size
     * 
     * TODO #12 - set up the sticky header, rewrite the js below.
	 */
// window.onscroll = function () {
//     scrollFunction();
//   };

//   function scrollFunction() {
//     if (document.body.scrollTop > 49 || document.documentElement.scrollTop > 49) {
//       document.getElementById("header").classList.add("stick");
//     } else {
//       document.getElementById("header").classList.remove("stick");
//     }
//   }

/**
 * multi-item sponsor carousel - slide by one.
*/
let items = document.querySelectorAll('#sponsorCarousel.carousel .carousel-item');
items.forEach(el => {
  const minPerSlide = 4;
  let next = el.nextElementSibling;

  for (var i = 1; i < minPerSlide; i++) {
    if (!next) {
      // wrap carousel by using first child
      next = items[0];
    }

    let cloneChild = next.cloneNode(true);
    el.appendChild(cloneChild.children[0]);
    next = next.nextElementSibling;
  }
});